$(() => {
	const $blurbClass = $('.bs-blurb--blog-inner-middle-image-content');
  $blurbClass.each((index, element) => {
  const $blurbInner = $(element).find('.bs-blurb__title, .bs-blurb__description, .bs-blurb__read-more');
  $blurbInner.wrapAll('<div class= "bs-blurb__details-wrapper"></div>');
  });
});